import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iw-shared-layout-container-authentication',
  templateUrl: './layout-container-authentication.component.html',
  styleUrls: ['./layout-container-authentication.component.scss']
})
export class LayoutContainerAuthenticationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  isDicom(): boolean{
    if(window.location.host == 'login.gesoft.de'){
      return true;
    }
    return false;
  }

}
